// react, react-redux
import React from 'react';
import { connect } from 'react-redux'

const thankyou = props => {
  const {formResponse, formData, formName} = props;
  return (
    <div>
      <h1>Thank you</h1>
      <p>Thanks for submitting your {formName.replace("Form", "")} application.</p>
      <p>Your <span className="thankyou-bold">receipt number</span> for this application is <span className="thankyou-bold">{formResponse.referenceNumber}</span>.</p>
      <p>A confirmation email will be sent to {(formData.primaryContact && formData.primaryContact.email) && formData.primaryContact.email} shortly.</p>
      <h2>Further Information</h2>
      <p>If you've got any further questions, please email us at <a href="mailto: heritage.permits@delwp.vic.gov.au">heritage.permits@delwp.vic.gov.au</a> or get in touch by phone on <a href="tel:03-7022-6370">03 7022 6370</a>.</p>
      <p>For all general DELWP enquiries, call <a href="tel:136-186">136 186</a>.</p>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { formResponse: (state.service.response) }
}

export default connect(mapStateToProps)(thankyou);